<template>
  <div class="text-start">
  <v-col :cols="!$vuetify.breakpoint.smAndDown ? '10' : ''" class="white black--text" :style="!$vuetify.breakpoint.smAndDown ? 'position: absolute; z-index: 1;' : ''">
    <div v-if="loading">
    <Loading/>
    </div>
    <v-container v-if="!loading">
      <v-row>
        <v-col>
          <v-btn
            class="primary btn"
            height="45"
            style="border-radius: 30px;"
            v-on:click="goBack">Go back
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          Quote <span class="primary--text">#{{  + Number.parseInt(order+1) }}</span>
        </v-col>
      </v-row>
      <div v-if="$vuetify.breakpoint.smAndDown">
        <v-row>
          <v-col style="display: block;">
            <h1 class="mb-4">Here's your quote</h1>
        </v-col>
        </v-row>
        <v-row style="display: block;">
          <v-col>
            <v-card elevation="10" height="100%" class="grey lighten-4">
              <v-card-text>
                <v-row>
                  <v-col>
                    <h2 v-if="!isTruckVehicle" class="black--text mb-4">Delivery</h2>
                    <h2 v-else class="black--text mb-4">Collection</h2>
                  </v-col>
                  <v-col align="end">
                    <h2 class="primary--text"> R {{ vehicle.cost }} </h2><span>(Fuel levy <span style="font-weight: bold;" class="primary--text">+R{{ fuelLevyPrice }}</span> ex VAT)</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <p v-if="!isTruckVehicle">
                      Bin placement, collection, disposal and landfill dump charges* (VAT inclusive)
                    </p>
                    <p v-else>
                      Collection, disposal and landfill dump charges* (VAT inclusive)
                    </p>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col v-if="!isTruckVehicle">
            <v-card elevation="0" height="100%" class="grey lighten-4">
              <v-card-text>
                <v-row>
                  <v-col>
                    <h2 v-if="vehicle.name.includes('Skip') || vehicle.name.includes('Flat') " class="black--text mb-4">Exchange</h2>
                  </v-col>
                  <v-col align="end">
                    <h2 class="primary--text"> R {{ vehicle.cost }} </h2> <span>(Fuel levy <span style="font-weight: bold;" class="primary--text">+R{{ fuelLevyPrice }}</span> ex VAT)</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <p>
                      Full bin collection and bring a new bin (exchange)
                      Bin exchange, disposal and landfill dump charges* (VAT inclusive)
                      Skip bin rental for 1 - 7 days
                    </p>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <br/><br/>
        <v-row>
          <v-col>
            Quote details
          </v-col>
          <v-col align="end">
            #{{ parseInt(order+1) }}
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row style="display: block;">
          <v-col>
            <h4 class="black--text mb-2">Your waste address is </h4>
            {{ capturedAddress }}
          </v-col>
          <v-col>
            <h4 class="black--text mb-2">Waste type </h4>
            {{ wasteType.name }}
          </v-col>
          <v-col>
            <h4 class="black--text mb-2">Service type </h4>
            <span> {{ vehicle.name }} </span>
          </v-col>
        </v-row>
        <br/><br/>
        <v-row style="display: block;">
          <v-col align="start" style="display: block; text-align: center;">
            <v-btn block rounded height="60" class="primary min-width" v-on:click="saveQuoteEventHandler">Book now</v-btn>
          </v-col>
        </v-row>
        <br/>
        <v-divider></v-divider>
        <br/>
        <v-row class="main--text mb-2" justify="center">
          <v-col>
            <p class="head1">Solve waste <br/> removal hassles.</p>
          </v-col>
        </v-row>
        <v-divider></v-divider>
      </div>


      <div v-if="!$vuetify.breakpoint.smAndDown">
        <v-row>
          <v-col>
            <h1 class="mb-4">Here's your quote</h1>
          </v-col>
          <v-col align="start">
            <v-btn rounded height="60" class="primary min-width" v-on:click="saveQuoteEventHandler">Book now</v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-card elevation="10" height="200" class="grey lighten-4">
              <v-card-text>
                <v-row>
                  <v-col>
                    <h2 v-if="!isTruckVehicle" class="black--text mb-4">Delivery</h2>
                    <h2 v-else class="black--text mb-4">Collection</h2>
                  </v-col>
                  <v-col align="end">
                    <h2 class="primary--text"> R {{ vehicle.cost }} </h2> <span>(Fuel levy <span style="font-weight: bold;" class="primary--text">+R{{ fuelLevyPrice }}</span>)</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <p v-if="!isTruckVehicle">
                      Bin placement, collection, disposal and landfill dump charges* (VAT inclusive)
                    </p>
                    <p v-else>
                      Collection, disposal and landfill dump charges* (VAT inclusive)
                    </p>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col v-if="!isTruckVehicle">
            <v-card elevation="0" height="200" class="grey lighten-4">
              <v-card-text>
                <v-row>
                  <v-col>
                    <h2 v-if="!isTruckVehicle" class="black--text mb-4">Exchange</h2>
                  </v-col>
                  <v-col align="end">
                    <h2 class="primary--text"> R {{ vehicle.cost }} </h2> <span>(Fuel levy <span style="font-weight: bold;" class="primary--text">+R{{ fuelLevyPrice }}</span>)</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <p>
                      Full bin collection and bring a new bin (exchange)
                      Bin exchange, disposal and landfill dump charges* (VAT inclusive)
                      Skip bin rental for 1 - 7 days
                    </p>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            Quote details
          </v-col>
          <v-col align="end">
            #{{ parseInt(order+1) }}
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row :style="$vuetify.breakpoint.smAndDown ? 'display: block' : ''">
          <v-col>
            <h4 class="black--text mb-2">Your waste address is </h4>
            {{ capturedAddress }}
          </v-col>
          <v-col>
            <h4 class="black--text mb-2">Waste type </h4>
            {{ wasteType.name }}
          </v-col>
          <v-col>
            <h4 class="black--text mb-2">Service type </h4>
            <span> {{ vehicle.name }} </span>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </v-col>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
export default {
  name: "ConfirmInfo",
  props: {
    goBack: Function,
    wasteType: Object,
    vehicle: Object,
    capturedAddress: String,
  },
  components:{
    Loading
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    async saveQuoteEventHandler() {
      this.loading = true;
      if(this.quoteId){
        this.$store.dispatch('toastr/addToastr', {
          id: `toast-${Date.now()}`,
          type: 't-info',
          title: 'Info',
          message: 'Booking in progress. Please sign up to confirm.',
          options: {
            timeout: 3000
          }
        });
        window.location.href = `https://app.dashwaste.co.za/quote-redirect?quoteId=${this.quoteId}`;
      }
      else{
        alert('Unable to proceed. Please contact us to book.');
        this.loading = false;
      }

    }
  },
  computed: {
    isTruckVehicle(){
      if (this.vehicle.name.toLowerCase().includes("truck") || this.vehicle.type.toLowerCase().includes("truck")) {
        return true;
      }
      return false;
    },
    quoteId(){
      return this.$store.getters.getQuoteId;
    },
    order(){
      return this.$store.getters.getOrder;
    },
    fuelLevyPrice() {
      return this.$store.state.fuelLevy.fuelLevyPrice;
    }
    /*cost(){
      let actualCost = parseInt(this.vehicle.cost);
      let discountedCost = actualCost - (actualCost * 0.1);
      return discountedCost.toString().includes(".") ? discountedCost.toFixed(2) : discountedCost;
    }*/
  }
}
</script>

<style scoped>
.head1{
  font-family: Avenir1;
  font-style: normal;
  font-weight: 750px;
  font-size: 56px;
  line-height: 64px;
}
.min-width {
  width: 150px;
}
.btn{
  width: 200px;
}

</style>
